import linkResolver from './linkResolver';

export default linkResolver;
